import { Outlet, useParams } from 'react-router-dom';
import { useBot, useChannels, useRevokeChannel } from '../../api/hooks';
import { CHANNEL_LABEL } from '../../domain/labels';
import { Breadcrumbs, Button, Dialog, ErrorNote, Loading, PageHeader, StatePill, Tabs } from '../../ui';
import { useState } from 'react';

export function ChannelLayout(): JSX.Element {
  const { botId = '', channelId = '' } = useParams();
  const bot = useBot(botId);
  const channels = useChannels(botId);
  const channel = channels.data?.find((c) => c.broadcasterUserId === channelId);
  const revoke = useRevokeChannel(botId);
  const [confirm, setConfirm] = useState(false);
  if (bot.isPending || channels.isPending) return <Loading />;
  if (!bot.data || !channel) return <ErrorNote>Chaîne introuvable</ErrorNote>;
  const base = `/bots/${botId}/channels/${channelId}`;
  return (
    <>
      <Breadcrumbs items={[{ to: '/', label: 'Bots' }, { to: `/bots/${botId}`, label: bot.data.name }, { label: channel.channel || channel.login }]} />
      <PageHeader
        title={channel.channel || channel.login}
        actions={
          <>
            <StatePill state={channel.status}>{CHANNEL_LABEL[channel.status]}</StatePill>
            <Button variant="danger" onClick={() => setConfirm(true)}>Révoquer</Button>
          </>
        }
      />
      <Tabs
        items={[
          { to: base, label: 'Abonnements', end: true },
          { to: `${base}/helix`, label: 'Actions' },
          { to: `${base}/scopes`, label: 'Scopes & accès' },
          { to: `${base}/features`, label: 'Fonctionnalités' },
          { to: `${base}/api-keys`, label: 'Clés API' },
          { to: `${base}/activity`, label: 'Activité' },
        ]}
      />
      <Outlet />
      <Dialog open={confirm} title="Révoquer cette chaîne ?" danger confirmLabel="Révoquer" onClose={() => setConfirm(false)} onConfirm={() => revoke.mutate(channelId)}>
        Les abonnements EventSub de cette chaîne seront arrêtés.
      </Dialog>
    </>
  );
}
